let $searchForm,
$inputForm,
$clearForm,
$headerSearch,
$toggleHeaderSearch,
$headerNavigation,
$searchComponent,
$main,
$footer,
$searchFAQ;

$(document).ready(function($) {

    $searchForm = $('.js-search-form');
    $inputForm = $('.js-search-input');
    $clearForm = $('.js-clear-form');
    $headerSearch = $('.js-header-search');
    $toggleHeaderSearch = $('.js-header-search-toggle');
    $headerNavigation = $('.js-search-header-menu');
    $searchComponent = $('.js-search-component');
    $main = $('.js-main');
    $footer = $('.js-footer');
    $searchFAQ = $('.js-search-faq');

    if ( $inputForm.length > 0 ) {
        $inputForm.keypress(function (e) {
          if (e.which == 13) {
            let targetForm = e.currentTarget.parentNode;
            targetForm.submit();
            return false;   
          }
        });
    }

    if ( $clearForm.length > 0 ) {
        $clearForm.on('click', function(e) {
            e.preventDefault();
            $inputForm.val('');
            $inputForm.focus();
            $(this).hide();
        });
    }

    if ( $headerSearch.length > 0 ) {
      
      if( $toggleHeaderSearch.length > 0 ) {
        $toggleHeaderSearch.on('click', function() {
          $searchComponent.toggleClass('is-active');
          $headerNavigation.toggleClass('is-active');
          $toggleHeaderSearch.toggleClass('is-active');

          $headerSearch.find('.js-search-input').focus();
          
          if ($(window).width() > 992){
            $main.toggleClass('show-overlay');
            $footer.toggleClass('show-overlay');
          }
        })
      }
    }

    if ( $searchFAQ.length > 0 ) {
      $typeInput.val('veelgestelde-vragen');
    }
});
